import React, {Component} from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <div>
        <p>
        404. Page Not Found.
        </p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/notFound.js